import React, { useState, useEffect } from "react";
import get from "lodash/get";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { SectionName } from "../../atoms/section-tag";
import { HeroImage } from "../../atoms/hero-image";
import { Headline } from "../../atoms/headline";
import { Subheadline } from "../../atoms/subheadline";
import { Authors } from "../../atoms/author";
import { isDesktopSizeViewport } from "../../../utils";
import { socialShareSupport } from "../../molecules/social-share";
import { checkIfStoryPublic, showStoryCards, handleAccess } from "../../../access-type-utils";
import { AmazonPolly } from "../../molecules/amazon-polly/amazon-polly";
import { ImageGallery } from "../../atoms/image-gallery";
import "./photo-story.m.css";
import { GiftStoryButton } from "../../molecules/gift-story-button";

const PhotoStoryTemplate = props => {
  const [deviceWidth, deviceWidthHandler] = useState("");
  useEffect(() => {
    deviceWidthHandler(!isDesktopSizeViewport() ? "full-width" : "");
  }, []);

  const isStoryPublic = checkIfStoryPublic(props.story);
  const story = isStoryPublic? props.story: props.hasSubscription ? props.story: props.newStory;
  const storyCards = get(story, [ "cards"], []);

  const firstSlideShow =
    (story.cards &&
      story.cards
        .reduce((acc, element) => {
          acc = acc.concat(element["story-elements"]);
          return acc;
        }, [])
        .find(({ metadata }) => metadata.type === "slideshow")) ||
    {};

  const HeaderSlideShow = props => {
    return (
      <div>
        <ImageGallery
          element={firstSlideShow}
          key={firstSlideShow.id}
          story={story}
          slideshowItem={firstSlideShow["story-elements"]}
        />
      </div>
    );
  };
  const { id: firstSlideShowId = -1 } = firstSlideShow;
  const getSlideShowElement = get(firstSlideShow, ["story-elements"], []);
  return (
    <div styleName="photo-story-wrapper">
      {(props.member && props.hasSubscription && getSlideShowElement.length > 0) ||
      (isStoryPublic && getSlideShowElement.length > 0) ? (
        <div className={`${deviceWidth}`}>
          <HeaderSlideShow story={story} firstSlideShow={getSlideShowElement} />
        </div>
      ) : (
        <div styleName="hero-image" className={`${deviceWidth}`}>
          <HeroImage story={story} />
        </div>
      )}
      <div styleName="story-header">
        <div styleName="section">
          <SectionName story={story} />
        </div>
        <div styleName="headline">
          <Headline story={story} isStoryPage />
        </div>
        <div styleName="subheadline">
          <Subheadline story={story} />
        </div>
        <div>{isStoryPublic || props.hasSubscription ? <AmazonPolly story={story} /> : null}</div>
        <div styleName="author">
          <Authors story={story} />
          {!isStoryPublic && props.hasSubscription ? <GiftStoryButton story={story} /> : null}
        </div>
      </div>

      <div styleName="story-content">
        <div styleName="social-share">
          <div styleName="sticky">{socialShareSupport(story)}</div>
        </div>
        <div styleName="story-cards">
          {isStoryPublic
            ? showStoryCards(storyCards, props.config, story, props.hasSubscription, firstSlideShowId)
            : handleAccess(storyCards, props.config, story, props.hasSubscription, firstSlideShowId)}
        </div>
      </div>
    </div>
  );
};

PhotoStoryTemplate.propTypes = {
  story: PropTypes.shape({
    cards: PropTypes.array
  }),
  config: PropTypes.object,
  member: PropTypes.object,
  hasSubscription: PropTypes.bool
};

class PhotoStoryAccessWrapper extends React.Component {
  render() {
    return (
      <div>
        <PhotoStoryTemplate {...this.props} />
      </div>
    );
  }
}
class PhotoStoryBase extends React.Component {
  render() {
    return <PhotoStoryAccessWrapper {...this.props} />;
  }
}

PhotoStoryBase.propTypes = {
  config: PropTypes.object
};

const mapStateToProps = state => ({
  config: get(state, ["qt", "config"], {}),
  member: get(state, ["member"], null),
  hasSubscription: get(state, ["isSubscribedUser", "userHasSubscription"], false)
});

export const PhotoStory = connect(mapStateToProps)(PhotoStoryBase);
